import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'warranty-status-badge',
  templateUrl: './warranty-status-badge.component.html',
  styleUrls: ['./warranty-status-badge.component.scss']
})
export class WarrantyStatusBadgeComponent implements OnInit {

  @Input() status: string;

  public textColor: string;
  public backgroundColor: string;

  ngOnInit(): void {
    this.textColor = this.getTextColor(this.status);
    this.backgroundColor = this.getBackgroundColor(this.status);
  }

  getTextColor(status: string): string {
    switch (status) {
      case 'active':
        return '#29A37A';
      case 'expired':
        return '#FF0000';
      case 'extended':
        return '#FFAA00';
      case 'future':
        return '#00AAFF';
      default:
        return null;
    }
  }

  getBackgroundColor(status: string): string {
    switch (status) {
      case 'active':
        return '#2fb6881a';
      case 'expired':
        return '#ff00001a';
      case 'extended':
        return '#ffaa001a';
      case 'future':
        return '#00aaff1a';
      default:
        return null;
    }
  }
}
